import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export interface VirtualizedListClasses {
	root: string;
	showBorder: string;
	wrapper: string;
	footer: string;
}

export const getVirtualizedListClass = (slot: string) =>
	generateUtilityClass('VirtualizedList', slot);

export const virtualizedListClasses = generateUtilityClasses<
	keyof VirtualizedListClasses
>('VirtualizedList', ['root', 'showBorder', 'wrapper', 'footer']);
export default virtualizedListClasses;
